import revive_payload_client_4sVQNw7RlN from "E:/github/khalej/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "E:/github/khalej/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "E:/github/khalej/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "E:/github/khalej/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "E:/github/khalej/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "E:/github/khalej/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "E:/github/khalej/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "E:/github/khalej/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "E:/github/khalej/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_UYiXMU8ZyN from "E:/github/khalej/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import plugin_gab9g3XuEx from "E:/github/khalej/node_modules/nuxt-aos/dist/runtime/plugin.js";
import primevue_plugin_egKpok8Auk from "E:/github/khalej/.nuxt/primevue-plugin.mjs";
import plugin_client_8fz26Kfk5j from "E:/github/khalej/node_modules/nuxt-primevue/dist/runtime/plugin.client.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "E:/github/khalej/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "E:/github/khalej/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import pinia_Uphuq97G1L from "E:/github/khalej/plugins/pinia.js";
import axios_sVCuMR6hEC from "E:/github/khalej/plugins/axios.js";
import sweetalert2_yFjEFOaS8h from "E:/github/khalej/plugins/sweetalert2.js";
import vue_toastificaton_qKaPuIPpA9 from "E:/github/khalej/plugins/vue-toastificaton.ts";
import vuetify_8NhHJigKc1 from "E:/github/khalej/plugins/vuetify.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_UYiXMU8ZyN,
  plugin_gab9g3XuEx,
  primevue_plugin_egKpok8Auk,
  plugin_client_8fz26Kfk5j,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  pinia_Uphuq97G1L,
  axios_sVCuMR6hEC,
  sweetalert2_yFjEFOaS8h,
  vue_toastificaton_qKaPuIPpA9,
  vuetify_8NhHJigKc1
]